import React from 'react';
import PropTypes from 'prop-types';

const CreditCardItem = ({
  card,
  handleSetDefault,
  deleteCard,
  isSettingDefault,
  isDeleting,
}) => {
  const ccDetails = card
    ? `${card.brand} ending in ${card.last4} Expiration: ${card.exp_month}/${
        card.exp_year
      }`
    : 'N/A';

  const isDefaultIcon = card.is_default ? (
    <span className="badge badge-pill badge-primary ml-2">Active</span>
  ) : null;

  return (
    <li className="list-group-item list-group-item-action d-flex justify-content-between">
      <div>
        <i
          className="fa fa-credit-card"
          aria-hidden="true"
          style={{ marginRight: 5 }}
        />
        <span style={{ fontFamily: 'Arial', fontSize: 12 }}>{ccDetails}</span>
        {isDefaultIcon}
      </div>
      <div>
        {!card.is_default && (
          <span>
            <button
              type="button"
              className="btn btn-primary btn-sm"
              onClick={() => {
                handleSetDefault(card);
              }}
              disabled={isSettingDefault}
            >
              {isSettingDefault && (
                <i className="fa fa-cog fa-spinner fa-spin fa-spin mr-1" />
              )}
              Set Active
            </button>
          </span>
        )}
        {!card.is_default && (<span>
          <button
            type="button"
            className="btn btn-danger btn-sm ml-2"
            onClick={() => {
              deleteCard(card.id);
            }}
            disabled={isDeleting}
          >
            {isDeleting && (
              <i className="fa fa-cog fa-spinner fa-spin fa-spin mr-1" />
            )}
            Delete
          </button>
        </span>
        )}
      </div>
    </li>
  );
};

CreditCardItem.propTypes = {
  card: PropTypes.object.isRequired,
  deleteCard: PropTypes.func.isRequired,
  handleSetDefault: PropTypes.func.isRequired,
};

export default CreditCardItem;



// WEBPACK FOOTER //
// ./src/views/Admin/CreditCardItem.js